export const homeRoutes = [
  {
    path: '/',
    redirect: '/dashboard',
  },
  {
    path: '/dashboard',
    component: () => import('@/views/modules/home/dashboard/dashboard'),
    meta: { name: 'Dashboard', keepAlive: true, closable: false, permission: 'dashboard:view' }
  },
  {
    path: '/seller-assistant',
    component: () => import('@/views/modules/home/seller-assistant/seller-assistant'),
    meta: { name: '海卖助手', keepAlive: true, permission: 'dashboard:assistant' }
  },
  {
    path: '/guide-video',
    component: () => import('@/views/modules/home/novice-guide/components/guide-video'),
    meta: { name: '新手指引-视频教程', keepAlive: true}
  },
];
